import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { SaveSingleColorWrapper } from "./components/save-single-color/save-single-color-wrapper";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";

const SaveSingleColorContext = createContext();
export const useSaveSingleColor = () => useContext(SaveSingleColorContext);
function SaveSingleColorProvider({ data, children }) {
  return (
    <SaveSingleColorContext.Provider value={data}>
      {children}
    </SaveSingleColorContext.Provider>
  );
}

function SaveSingleColorRenderer() {
  const elements = document.querySelectorAll(".react-save-single-color");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(error, "Could not parse initial props JSON for SaveSingleColor");
    }
    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <SaveSingleColorProvider data={initialProps}>
            <SaveSingleColorWrapper />
          </SaveSingleColorProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initSaveSingleColor = () => {
  if (document.readyState !== "loading") {
    SaveSingleColorRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", SaveSingleColorRenderer);
  }
};

export { SaveSingleColorWrapper, SaveSingleColorProvider };
